export default "__VITE_ASSET__aWvuzB1C__"